import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteHeaderProvider } from '@shapeable/ui';
import { DOING_DEEP_BLUE } from '../../theme';
import { BannerOutroLogosImage } from '../elements/banner-outro-logos-image';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__banner-titles {
      width: 160px;
    }
    .shp--page-layout-standard__title {
      font-weight: 600;
      font-family: ${theme.FONT('heading')};
      margin-bottom: ${theme.UNIT(2)};
      font-size: 2.5em;
      color: ${theme.COLOR(DOING_DEEP_BLUE)};
    }

    /* For site header nav (menu-link-item) jump links */
    [id] {
      scroll-margin-top: 100px;
    }
  `,
  landscape: css`
    .shp--page-layout-standard__title {
      font-size: 3.3em;
    }

    .shp--page-layout-standard__banner-titles {
      width: 212px;
    }
  `,
  tablet: css`
    .shp--banner-titles {
      width: 100%;
    }

    .shp--page-layout-standard__banner-titles {
      width: 305px;
    }

    .shp--page-layout-standard__title {
      font-size: 4.5em;
      letter-spacing: 2px;
      margin-bottom: ${theme.UNIT(5)};
    }
  `,
  desktop: css`
    .shp--page-layout-standard__title {
      font-size: 6em;
    }

    .shp--page-layout-standard__banner-titles {
      width: 405px;
    }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutBentleyTogether: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <SiteHeaderProvider value={{
      variant: 'default',
      boundary: 'content'
    }}>
    <My.Layout 
      className={className}
      entity={entity}
      slices={slices}
      headerProps={{ 
        aspectRatio: { base: 16/9, desktop: 21/9 },
        showOverlayGradient: true,
        fadeColor: '#0000000', 
        overlayColor: '#00000011',
        // backgroundColor: '#0000000',
        useBackgroundColor: true }} 
    afterBannerTitles={<BannerOutroLogosImage />}
    />
    </SiteHeaderProvider>
  )
};